export var durationRegular = 200;